import React from 'react';
import styled from 'styled-components';
import Form from '../Form';
import Button from '../Button';
import { withTranslation } from '../../../hoc';
import { ModalStyle } from './styled';
import './index.css';


const FormModalWrapper = styled.div`
  ${ModalStyle}
  &&& {
    display: ${({ open }) => (open ? 'flex' : 'none')};
  }
`;

const StyledButton = styled(Button)`
  && {
    min-width: 80px;
  }
`;

const StyledDiv = styled.div``;

const FormMode = withTranslation((rawProps) => {
  const {
    className = '',
    tr,
    onSubmit = () => {},
    title = 'No title',
    actionButtonName = 'Add',
    children = <span>No children</span>,
    isLoading = false,
    toggleForm = () => {},
    render = null,
    renderActionButtons = null,
    open = false,
    validationSchema = {},
    formData = {},
    loadingData,
    style = {},
    ...rest
  } = rawProps;

  const props = {
    ...rest,
    className,
    tr,
    onSubmit,
    title,
    actionButtonName,
    children,
    isLoading,
    toggleForm,
    render,
    renderActionButtons,
    open,
    validationSchema,
    formData,
    loadingData,
    style,
  };

  return (
    <FormModalWrapper open={open} className={`modal-wrapper ${className}`}>
      <div style={props.styles} className="body">
        <Form
          onSubmit={onSubmit}
          title={title}
          validationSchema={validationSchema}
          formData={formData}
          children={children}
          loadingData={loadingData}
          renderActionButtons={
            renderActionButtons ||
            (() => (
              <div className="card-footer text-right">
                <div className="d-flex">
                  <StyledButton
                    type="submit"
                    className="btn-primary"
                    actionButton
                    isLoading={isLoading}
                    name={tr(actionButtonName)}
                  />
                </div>
              </div>
            ))
          }
          render={render && render(props)}
        />
      </div>
    </FormModalWrapper>
  );
});


export default withTranslation(FormMode);
